const packGrams = row => {
  const quantity = Number(row.quantity ?? row.catalogQuantity ?? row.barcode_quantity);
  const unit = String(row.unit_short_code || row.unit_name || row.units || row.unit || '').trim().toLowerCase();
  const factor = ['kg', 'kgs', 'kilogram', 'kilograms'].includes(unit) ? 1000
    : ['g', 'gm', 'gms', 'gram', 'grams'].includes(unit) ? 1 : 0;
  return Number.isFinite(quantity) && quantity > 0 ? quantity * factor : 0;
};

export function smallerPackCosts(source, products, price) {
  const grams = packGrams(source || {});
  const cost = Number(price);
  if (!grams || !Number.isFinite(cost) || cost <= 0) return [];
  // Match catalog identity and warehouse; names alone can refer to different goods.
  const keys = ['product_id', 'brand_id', 'category_id', 'warehouse_id'];
  if (keys.some(key => source[key] == null || source[key] === '')) return [];
  return products.filter(row => String(row.id) !== String(source.id)
    && row.is_active !== false
    && keys.every(key => String(row[key]) === String(source[key]))
    && packGrams(row) > 0 && packGrams(row) < grams)
    .map(row => ({ row, price: Math.ceil(Number((cost * packGrams(row) / grams).toFixed(8))) }));
}
